import React,{useEffect,useState} from 'react';
import {Link,useLocation} from 'react-router-dom';

function HeaderComponent() {
	const location = useLocation();
	const pathName = location.pathname;
	const [active,setActive] = useState('');
	
	useEffect(()=>{
		setActive(pathName);
		return()=>{}
	},[pathName])

	return(
		<>
		<nav className="navbar navbar-expand-lg fixed-top c-topNavbar">		
			<div className="container d-flex">
				<Link to='/'  className="navbar-brand c-scrollToDiv" data-scroll-to="#c-sectionMainSlider">
					<img src="./images/logo/finayo-logo.png" alt="Finayo" title="" className="c-mainLogo" />
				</Link>
				<button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
					aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon">
						<svg className="bi c-menuExpand" width="1em" height="1em">
							<use href="images/bootstrap-icons.svg#list"></use>
						</svg>
						<svg className="bi c-menuClose" width="1em" height="1em">
							<use href="images/bootstrap-icons.svg#x-lg"></use>
						</svg>
					</span>
				</button>
				<a className="btn btn-outline-primary c-btnOrangeSolid c-topNavbarGetStarted" target="_blank" href="http://finayo.club">Get Started</a>
				<div className="collapse navbar-collapse" id="navbarCollapse">
					<ul className="navbar-nav ml-auto">					
					  <li className={active === '/lender' ? 'nav-item active': 'nav-item'}>
						<Link to='/lender' className="nav-link c-scrollToDiv" data-scroll-to="#c-heroLender">Lender</Link>
					  </li>
					  <li className={active === '/dealer' ? 'nav-item active': 'nav-item'}>
						<Link to='/dealer' className="nav-link c-scrollToDiv" data-scroll-to="#c-heroDealer">Dealer</Link>
					  </li>
					  <li className={active === '/about' ? 'nav-item active': 'nav-item'}>
						<Link to='/about' className="nav-link c-scrollToDiv" data-scroll-to="#c-heroAboutUs">About Us</Link>
					  </li>
					  <li className={active === '/oem' ? 'nav-item active': 'nav-item'}>
						<Link to='/oem' className="nav-link c-scrollToDiv" data-scroll-to="#c-heroOem">OEM</Link>
					  </li>
					  <li className={active === '/how-it-works' ? 'nav-item active': 'nav-item'}>
						<Link to='/how-it-works' className="nav-link c-scrollToDiv" data-scroll-to="#c-sectionHowFinayoWorks">How it Works</Link>
					  </li>
					  {/* <!-- <li className="nav-item active">
						<a className="nav-link" href="#">Home <span className="sr-only">(current)</span></a>
					  </li> --> */}
					</ul>
				</div>			
			</div>
		</nav>
		</>
	)
}
export default HeaderComponent;